import React, { useState } from "react";
import { getProviderLogo, providerInitials, providerTone } from "../utils/providerLogos";

const ProviderLogo = ({ name, src, className = "" }) => {
  const [broken, setBroken] = useState(false);
  const logo = !broken ? getProviderLogo(name, src) : "";

  if (!logo) {
    return (
      <span className={`provider-logo fallback ${className}`} style={{ background: providerTone(name) }} aria-hidden>
        {providerInitials(name)}
      </span>
    );
  }

  return (
    <img
      className={`provider-logo ${className}`}
      src={logo}
      alt=""
      onError={() => setBroken(true)}
    />
  );
};

export default ProviderLogo;
